import { useEffect, useRef } from "react";
import { useField } from "formik";
import { FormGroup, Label } from "reactstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Typeahead } from "react-bootstrap-typeahead";

type FormikMultiSelectSearchProps = {
  label: string;
  name: string;
  options: any[];
  placeholder: string;
  multiple?: boolean;
  labelKey?: string;
  labelClassName?: string;
};

const FormikMultiSelectSearch = ({
  label,
  name,
  options,
  placeholder,
  multiple = true,
  labelKey,
  labelClassName = "",
}: FormikMultiSelectSearchProps) => {
  const [field, meta, helpers] = useField(name);
  const selectedValue = field.value || [];

  const typeaheadRef = useRef<any>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        typeaheadRef.current?.blur(); // This will hide the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={containerRef}>
      <FormGroup>
        <Label className={`col-form-label ${labelClassName}`}>{label}</Label>
        <Typeahead
          id={name}
          ref={typeaheadRef}
          className="f-12"
          labelKey={labelKey || "name"}
          multiple={multiple}
          options={options}
          placeholder={placeholder}
          selected={selectedValue}
          onChange={(selected: any[]) => helpers.setValue(selected)}
          onBlur={() => helpers.setTouched(true)}
        />
        {meta.touched && meta.error && (
          <div className="invalid-feedback d-block">{meta.error}</div>
        )}
      </FormGroup>
    </div>
  );
};

export default FormikMultiSelectSearch;
